module.exports = __webpack_public_path__ + "static/img/result_main_banner.2a10c2c1.png";